// import React from "react";
import { motion } from "framer-motion";

import {
  FaArrowRight,
  FaCheckCircle,

} from "react-icons/fa";
import { useNavigate } from "react-router-dom";

function About() {

  const navigate=useNavigate();

  const features = [
    "End-to-end blockchain development",
    "Smart contract audit & security",
    "Cross-chain integration expertise",
    "AI-powered automation solutions",
  ];


  return (
    <section
      id="about"
      className="relative py-20 md:py-28 overflow-hidden bg-white"
    >
      {/* Static Background Elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-bl from-[#12AF09]/5 to-transparent rounded-full blur-[80px]"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-gradient-to-tr from-[#12AF09]/5 to-transparent rounded-full blur-[80px]"></div>

      {/* Subtle Grid Overlay */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#f0f0f0_1px,transparent_1px),linear-gradient(to_bottom,#f0f0f0_1px,transparent_1px)] bg-[size:60px_60px] opacity-25"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        {/* Page Title - Simple fade */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mb-5"
        >
          <div className="inline-flex items-center gap-3 bg-white/80 backdrop-blur-sm border border-gray-200 rounded-full px-5 py-2 shadow-sm">
            <div className="w-2 h-2 rounded-full bg-[#12AF09]"></div>
            <span className="text-sm font-medium text-gray-600 tracking-wide">
              PAGE 01
            </span>
            <div className="w-10 h-px bg-gray-300"></div>
            <span className="text-sm font-semibold text-[#12AF09]">ABOUT</span>
          </div>
          <h2 className="text-3xl md:text-6xl font-bold text-gray-900 mt-6 tracking-tight">
            Who We Are
          </h2>
        </motion.div>

        {/* Main Content Grid */}
        <div className="grid lg:grid-cols-2 gap-10 items-start">
          {/* Left Content - Staggered children */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="space-y-8"
          >
            <div className="space-y-6">
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 leading-tight">
                Chain Magician Lab —
                <span className="text-[#12AF09] block">
                  Building Scalable Digital Solutions with AI
                </span>
              </h3>

              <p className=" text-gray-600 leading-relaxed">
                Chain Magician Lab is a modern technology company focused on
                delivering innovative and scalable digital solutions for
                businesses worldwide. We specialize in blockchain development,
                AI-powered software, high-performance websites, and mobile
                application development, helping startups and enterprises
                transform their ideas into powerful digital products.
              </p>

              {/* Feature List */}
              <div className="space-y-4 pt-4">
                {features.map((feature, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, x: -20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.4, delay: index * 0.1 }}
                    className="flex items-center gap-3"
                  >
                    <FaCheckCircle className="text-[#12AF09] text-xl flex-shrink-0" />
                    <span className="text-gray-700">{feature}</span>
                  </motion.div>
                ))}
              </div>
            </div>

            {/* CTA Section */}
            <div className="flex flex-wrap gap-4 pt-6">
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="group bg-gradient-to-r from-[#12AF09] to-[#1d9413] text-white px-8 py-4 rounded-full font-semibold hover:shadow-xl hover:shadow-[#12AF09]/25 transition-all duration-300 flex items-center gap-2"
                onClick={() => {
                  navigate('/about')
                }}
              >
                Discover Our Company
                <FaArrowRight className="group-hover:translate-x-1 transition-transform" />
              </motion.button>

              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => {
                  navigate('/work')
                }}
                className="group bg-white border-2 border-gray-200 text-gray-700 px-8 py-4 rounded-full font-semibold hover:border-[#12AF09] hover:text-[#12AF09] transition-all duration-300"
              >
               How We Work
              </motion.button>
            </div>

          </motion.div>

          {/* Right Content - Simple fade */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="relative"
          >
            {/* Main Image Container */}
            <div className="relative rounded-3xl overflow-hidden ">
              <img
                src="./img/M3.png"
                alt="AI & Blockchain Technology"
                className="w-full h-auto object-cover"
              />
              {/* Static Gradient Overlay */}
              {/* <div className="absolute inset-0 bg-gradient-to-tr from-[#12AF09]/20 via-transparent to-transparent"></div> */}
            </div>

  

           
          </motion.div>
        </div>

        {/* Bottom Decorative Wave */}
        <div className="mt-0 h-px w-full bg-gradient-to-r from-transparent via-[#12AF09]/20 to-transparent"></div>
      </div>
    </section>
  );
}

export default About;
